import { replaceEntity } from './replaceEntity'
import { Identifiable, Optional } from './types'

export function replaceEntityById<T extends Identifiable>(entities: Optional<T[]>, updatedEntity: T) {
	return replaceEntity(entities, updatedEntity.id, updatedEntity)
}
